import DialogListItem from './DialogListItem';

export default DialogListItem;



// WEBPACK FOOTER //
// ./src/ondemand/components/DialogListItem/index.js